import request from '@/utils/httpClient'
import { MarketFeeCreateParams, MarketFeeUpdateParams } from '@/types/domain/fee'

// 创建业务市场费：新增地址由调用方传入（业务单维度的 business/{id}/actions/marketFee），与修改地址 businessMarketFee/{id} 不同
export function createMarketFee(url: string, data: MarketFeeCreateParams, method?: string) {
  const _method = method ? 'PUT' : 'POST'
  return request({
    url,
    method: _method,
    data
  })
}

// 更新业务市场费
export function updateMarketFee(id: number, data: MarketFeeUpdateParams) {
  return request({
    url: `businessMarketFee/${id}`,
    method: 'put',
    data
  })
}
// 支付确认
export function paymentConfirm(data?: object) {
  return request({
    url: 'businessMarketFee/actions/paymentConfirm',
    method: 'put',
    data
  })
}
